import { getCookie, readObj } from "Service/storage";
import { CommandScope } from "./types";

let activeScopeKey: string | null = null;

export function setActiveCommandScope(scopeKey: string | null) {
  activeScopeKey = scopeKey;
}

/** Also checks storage/cookies because logout clears them before React commits. */
export function isCommandScopeCurrent(scope: CommandScope): boolean {
  try {
    const account = readObj("account");
    return (
      activeScopeKey === scope.key &&
      !!getCookie("access") &&
      String(account?.id ?? "") === scope.userId
    );
  } catch {
    return false;
  }
}
